var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitorCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9883 20.2947L22.9883 24.2947L30.9883 16.2947M24.9883 34.2947V42.2947M16.9883 42.2947H32.9883M8.98828 6.29468H40.9883C43.1974 6.29468 44.9883 8.08554 44.9883 10.2947V30.2947C44.9883 32.5038 43.1974 34.2947 40.9883 34.2947H8.98828C6.77914 34.2947 4.98828 32.5038 4.98828 30.2947V10.2947C4.98828 8.08554 6.77914 6.29468 8.98828 6.29468Z",
    stroke: "url(#paint0_linear_1601_12086)",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1601_12086",
    x1: 24.9883,
    y1: 6.29468,
    x2: 24.9883,
    y2: 42.2947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorCheck);
export default __webpack_public_path__ + "static/media/monitor-check.c62019790c4335979a319e15d30eaa24.svg";
export { ForwardRef as ReactComponent };